import { useEffect, useRef } from 'react';
import { usePagination, useQueryParams } from '@/hooks';

interface UseTasksPaginationProps {
  /**
   * Cambia cada vez que se aplica un filtro distinto: al cambiar volvemos a la
   * primera página, si no se puede quedar pidiendo un offset que ya no existe
   * y la tabla aparece vacía.
   */
  filterKey?: string;
}

const useTasksPagination = ({ filterKey }: UseTasksPaginationProps = {}) => {
  const { setQueryParams, getQueryParam } = useQueryParams();
  const { currentPage, pageSize, handlePageChange, handlePageSizeChange } =
    usePagination({
      initialPage: Number(getQueryParam('page')) || 1,
      initialPageSize: Number(getQueryParam('pageSize')) || 10,
    });

  const previousFilterKey = useRef(filterKey);

  useEffect(() => {
    if (previousFilterKey.current === filterKey) return;
    previousFilterKey.current = filterKey;
    if (currentPage !== 1) handlePageChange(1);
  }, [filterKey, currentPage, handlePageChange]);

  useEffect(() => {
    setQueryParams({
      page: currentPage.toString(),
      pageSize: pageSize.toString(),
    });
  }, [currentPage, pageSize]);

  return {
    currentPage,
    pageSize,
    handlePageChange,
    handlePageSizeChange,
  };
};

export default useTasksPagination;
